function SvgComponent({ fillColor = '#C95045', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6325 10.1566C16.6325 7.3088 14.0464 5 10.8558 5C9.75034 5 8.85361 7.3088 8.85361 10.1566C8.85361 10.8689 8.90969 11.5481 9.01127 12.1657H7.05019L5 19.3326H10.8577V15.3151C14.0464 15.3151 16.6319 13.0051 16.6319 10.1585L16.6325 10.1573V10.1566ZM10.8558 5.94408C11.4354 5.94408 11.904 7.83101 11.904 10.1566C11.904 12.4829 11.4354 14.3692 10.8564 14.3692C10.2769 14.3692 9.80891 12.4829 9.80891 10.1566C9.80891 7.83101 10.2775 5.94408 10.8558 5.94408Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7454 15.3146H10.8628L13.1186 19.3327H19L16.7454 15.3146Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
